import { createFileRoute } from '@tanstack/react-router';
import { validateTableSearch } from '@utils/tabHelpers';

export const Route = createFileRoute('/t/contracts/')({
  validateSearch: (search: Record<string, unknown>) =>
    validateTableSearch(search, { sortBy: 'createdOn', sortDir: 'desc' }),
});
